/**
 * Eksodi 99 — Making of: truncate long video descriptions with Read more / Read less.
 */

const initEksodiMakingReadmore = () => {
  const blocks = document.querySelectorAll('[data-making-desc]');
  if (!blocks.length) {
    return;
  }

  blocks.forEach(block => {
    const inner = block.querySelector('[data-making-desc-inner]');
    const btn = block.querySelector('[data-making-readmore]');
    if (!inner || !btn) {
      return;
    }

    const labelMore = btn.dataset.labelMore || 'Read more';
    const labelLess = btn.dataset.labelLess || 'Read less';

    block.classList.add('is-collapsed');

    if (inner.scrollHeight <= inner.clientHeight) {
      block.classList.remove('is-collapsed');
      btn.hidden = true;
      return;
    }

    btn.hidden = false;

    btn.addEventListener('click', () => {
      const expanded = block.classList.toggle('is-expanded');
      block.classList.toggle('is-collapsed', !expanded);
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? labelLess : labelMore;
    });
  });
};

export default initEksodiMakingReadmore;
